var randomPrize = randomPrize || {};

(function ($, window) {
  Drupal.behaviors.spinnerGameUkv2 = {
    attached: false,
    attach: function (context) {
      if (this.attached) {
        return;
      }

      this.attached = true;

      var winningOffer;
      var winningCode;
      var offerSlice;
      var winningSlice;
      var spinsPlayed = 1;
      var offerCodes;
      var images = [
        'mauve',
        '20',
        'bag',
        'base',
        'crimson',
        '10',
        'eyeliner',
        'mascara',
        'mask',
        'moisturizin',
        'peony'
      ];
      var module = {
        options: {
          classNames: {
            hide: 'hidden',
            invisibile: 'invisible',
            animate: 'game-wheel__pointer--animate',
            rotate: 'game-wheel__main__img--rotate',
            showTerms: 'game-overlay--show-terms',
            isAnimating: 'is-animating',
            disabled: 'disabled',
            proUserState: 'game-formatter--pro-user'
          },
          wheel: {
            slices: 10,
            oneSpin: 360,
            spins: 3, // no. of times to go round
            tryAgain: 324, // degrees to spin to try again slice
            wheelSpeed: 4000,
            wheelSpeedDelay: 200
          }
        },

        setTerms: function (hide) {
          if (hide) {
            this.$overlay.removeClass(this.options.classNames.showTerms);
          } else {
            this.$overlay.addClass(this.options.classNames.showTerms);
          }

          this.$overlayWrapper.addClass(this.options.classNames.isAnimating);
        },

        setImages: function (hideFirstImage) {
          var getCustomLocale = $('.js-game-wheel__center__custom-locale').val() || '';
          var customLocale = getCustomLocale ? getCustomLocale + '-' : '';

          $.each(images, function (index, value) {
            this.$wheelCenter.append('<img src="/media/export/cms/game/wonder_wheel/middle_wheel-' + customLocale + value + '.png" class="prize_' + index + '">');
          }.bind(this));

          if (hideFirstImage) {
            this.$wheelCenter.children('img').first().hide();
          }
        },

        animateImages: function () {
          this.$wheelCenter.find('h2').hide();
          var i = 0;

          setInterval(function () {
            $('img.prize_' + i).remove();
            i++;
          }.bind(this), this.options.wheel.wheelSpeed / images.length);
        },

        setOfferCopy: function (offer) {
          this.$prizeImage.attr('src', offer.image);
          this.$prizeText.text(offer.description);
        },

        setTurnsRemaining: function () {
          var getNumberOfTries = randomPrize.getNumberOfTriesCookie() || 0;
          var getMaxNumberOfTries = randomPrize.getMaxNumberOfTries();
          var numberOfTriesRemaining = getMaxNumberOfTries - getNumberOfTries;

          if (getNumberOfTries <= getMaxNumberOfTries) {
            $.each(this.$gameTurns, function (index, element) {
              var $element = $(element);
              var $turnsTextPlural = $('.js-game-turns__plural', $element);
              var $turnsTextSingular = $('.js-game-turns__singular', $element);

              $('.js-game-turns__remaining', $element).text(numberOfTriesRemaining);

              $element.addClass('game-turns--' + numberOfTriesRemaining);

              if (numberOfTriesRemaining === 1) {
                $turnsTextPlural.addClass(this.options.classNames.hide);
                $turnsTextSingular.removeClass(this.options.classNames.hide);
              } else {
                $turnsTextPlural.removeClass(this.options.classNames.hide);
                $turnsTextSingular.addClass(this.options.classNames.hide);
              }
            }.bind(this));
          }

          if (numberOfTriesRemaining === 0) {
            this.$playBtn.addClass(this.options.classNames.invisibile);
            this.$playAgainBtn.addClass(this.options.classNames.hide);
            randomPrize.set24HourCookie();
          }
        },

        playGame: function (playAgain) {
          this.$wheelCenter.children('img').first().show();
          var win = randomPrize.getWinOrLose();
          var fullSpins = this.options.wheel.oneSpin * this.options.wheel.spins * spinsPlayed;
          var oneSlice = this.options.wheel.oneSpin / this.options.wheel.slices;

          if (!this.isPlaying) {
            this.animateImages();
            randomPrize.setNewPrize(playAgain);

            if (win === false) {
              offerSlice = this.options.wheel.tryAgain + (fullSpins - this.options.wheel.oneSpin);

              setTimeout(function () {
                randomPrize.setLoseState();
                this.$loseText.show();
                this.setImages(true);
              }.bind(this), this.options.wheel.wheelSpeed);

              spinsPlayed++;
            } else {
              spinsPlayed = 1; // reset wheel back to position
              winningOffer = randomPrize.getWinningOffer();
              winningCode = winningOffer.winningOffer.offer_code;
              winningSlice = offerCodes.indexOf(winningCode);
              offerSlice = fullSpins + (oneSlice * winningSlice);

              this.setOfferCopy(winningOffer);

              setTimeout(function () {
                this.$winText.show();
              }.bind(this), this.options.wheel.wheelSpeed);

              setTimeout(function () {
                randomPrize.setWinState();
                this.$wheel.removeClass(this.options.classNames.rotate);
                this.$wheel.removeAttr('style');
                this.setImages(true);
              }.bind(this), this.options.wheel.wheelSpeed + this.options.wheel.wheelSpeedDelay);
            }

            this.$pointer.addClass(this.options.classNames.animate);
            this.$wheel.addClass(this.options.classNames.rotate);

            this.$wheel.css({
              'transform': 'rotate(' + offerSlice + 'deg)',
              '-webkit-transform': 'rotate(' + offerSlice + 'deg)'
            });

            randomPrize.setNumberOfTriesCookie();
            this.setTurnsRemaining();
            this.isPlaying = true;

            setTimeout(function () {
              this.$pointer.removeClass(this.options.classNames.animate);
              this.isPlaying = false;
              this.$playBtn.removeClass(this.options.classNames.disabled);
            }.bind(this), this.options.wheel.wheelSpeed);
          }
        },

        applyOffer: function (redirect) {
          randomPrize.applyOffer(function () {
            $.when(randomPrize.offerApplied).then(function () {
              window.location.href = redirect;
            });
          });
        },

        setEvents: function () {
          this.$termsLinks1.on('click', function (event) {
            event.preventDefault();

            $(event.currentTarget).next().toggleClass(this.options.classNames.hide);
          }.bind(this));

          this.$termsLinks2.on('click', function (event) {
            event.preventDefault();

            this.setTerms();
          }.bind(this));

          this.$overlayWrapper.on('msTransitionEnd webkitTransitionEnd transitionend', function () {
            this.$overlayWrapper.removeClass(this.options.classNames.isAnimating);
          }.bind(this));

          this.$playBtn.on('click', function (event) {
            event.preventDefault();
            if (!this.$playBtn.hasClass(this.options.classNames.disabled)) {
              this.$playBtn.addClass(this.options.classNames.disabled);
              this.playGame();
            }
          }.bind(this));

          this.$applyOfferBtn.on('click', function (event) {
            event.preventDefault();

            this.applyOffer(event.target.href);
          }.bind(this));

          this.$playAgainBtn.on('click', function (event) {
            event.preventDefault();
            if (!this.$playBtn.hasClass(this.options.classNames.disabled)) {
              this.$playBtn.addClass(this.options.classNames.disabled);
              this.playGame(true);
            }
          }.bind(this));

          this.$backBtn.on('click', function (event) {
            event.preventDefault();

            this.setTerms(true);
          }.bind(this));
        },

        setElements: function () {
          this.$gameFormatter = this.$element.parent();
          this.$termsLinks1 = $('.js-game-terms__link--1', this.$element);
          this.$termsLinks2 = $('.js-game-terms__link--2', this.$element);
          this.$pointer = $('.js-game-wheel__pointer', this.$element);
          this.$wheel = $('.js-game-wheel__main__img', this.$element);
          this.$wheelCenter = $('.js-game-wheel__center', this.$element);
          this.$winText = $('.js-game-wheel__center--win', this.$element);
          this.$loseText = $('.js-game-wheel__center--lose', this.$element);
          this.$playBtn = $('.js-button--play', this.$element);
          this.$gameTurns = $('.js-game-turns', this.$element);
          this.$prizeImage = $('.js-game-overlay__section--won .js-game-overlay__image', this.$element);
          this.$prizeText = $('.js-game-overlay__section--won .js-game-overlay__text', this.$element);
          this.$applyOfferBtn = $('.js-button--redeem', this.$element);
          this.$playAgainBtn = $('.js-button--play-again', this.$element);
          this.$overlay = $('.js-game-overlay', this.$element);
          this.$overlayWrapper = $('.js-game-overlay__wrapper', this.$element);
          this.$backBtn = $('.js-game-overlay__back-link', this.$element);
        },

        isProUser: function () {
          var cookie = randomPrize.getCookie('APPLIED_OFFERS');

          return cookie && cookie.indexOf('bobbipro') > -1 ? true : false;
        },

        init: function (element) {
          this.$element = $(element);

          if (!window.randomPrize) {
            return;
          }

          randomPrize.isCookieNextDay = true;

          randomPrize.init(function () {
            if (randomPrize.isOffers) {
              if (!randomPrize.getNextDayCookie()) {
                randomPrize.setNextDayCookie();
              }

              this.setElements();

              if (this.isProUser()) {
                randomPrize.hidePopup();

                this.$gameFormatter.addClass(this.options.classNames.proUserState);

                return false;
              }

              this.setEvents();
              this.setTurnsRemaining();
              this.setImages();

              if (randomPrize.isAlreadyPlayed()) {
                randomPrize.setWinState();

                var cookie = randomPrize.getWinningOfferCookie();
                var currentOffer = randomPrize.getCurrentOffer(cookie);

                this.setOfferCopy(currentOffer);
              }

              if (randomPrize.get24HourCookie()) {
                randomPrize.getUnavailableMessage();
              }

              offerCodes = randomPrize.getAllOfferCodes();
            }
          }.bind(this), false);
        }
      };

      module.init(context.querySelector('.js-game--spinner'));
    }
  };
})(jQuery, window);
